export default {
  // Form
  employee: 'Employee',
  selectEmployee: 'Select an employee',
  applyChangesTo: 'Apply changes to',
  thisShiftOnly: 'This shift only',
  thisAndLaterShifts: 'This and later shifts',
  startingFrom: 'Starting from',
  keepsOwnDate: 'Each shift in the series keeps its own date.',
  endsNextDay: 'Ends the next day.',
  notesHint: 'Optional. Visible to the employee.',
  notesPlaceholder: 'e.g. Bring hi-vis and steel caps',

  // New shift
  newShift: 'New shift',
  newShiftDescription: 'Assign an employee to a site and time.',
  createShift: 'Create shift',
  createdShiftsOne: 'Created {count} shift.',
  createdShiftsOther: 'Created {count} shifts.',
  createdShiftsSkipped: 'Created {count} shifts ({skipped} skipped: {details}).',
  createdShiftsSkippedBooked: 'Created {count} shifts ({skipped} skipped — already booked).',
  shiftCreated: 'Shift created.',

  // Edit shift
  editTitle: '{employee} at {site}',
  editShift: 'Edit shift',
  cancelled: 'Cancelled',
  cancelThisAndFuture: 'Cancel this + future',
  cancelJustThis: 'Cancel just this one',
  cancelShift: 'Cancel shift',
  cancelledNotice: "This shift was cancelled, so it can't be edited. Create a new shift instead.",
  backToRoster: 'Back to roster',
  saveThisAndLater: 'Save this and later shifts',
  updatedShiftsOne: 'Updated {count} shift',
  updatedShiftsOther: 'Updated {count} shifts',
  updatedDone: '{updated}.',
  updatedSkipped: '{updated}. {skipped} left unchanged: {details}.',
  shiftUpdated: 'Shift updated.',
  cancelSeriesMessage: "Cancel this and every future shift in the series for {employee} at {site}? They'll get one notification for all of them.",
  cancelOneMessage: "Cancel {employee}'s shift at {site}? They'll be notified.",
  cancelSeriesConfirm: 'Cancel this and future shifts',
  shiftCancelled: 'Shift cancelled.',

  // Repeating series
  addedShiftsOne: 'Added {count} shift',
  addedShiftsOther: 'Added {count} shifts',
  addedDone: '{added}.',
  addedSkipped: '{added}. {skipped} skipped: {details}.',
  cancelledAfterOne: 'Cancelled {count} shift after {date}.',
  cancelledAfterOther: 'Cancelled {count} shifts after {date}.',
  seriesEndUpdated: 'Series end date updated.',
  repeatingSeries: 'Repeating series',
  seriesSummary: '{employee} at {site}, {days} · {start}–{end}, from {from} until {to}. {count} scheduled.',
  seriesInferred: "This older series' pattern was worked out from its shifts.",
  repeatsUntil: 'Repeats until',
  shortenHint: 'Shifts after this date will be cancelled.',
  shortenSeries: 'Shorten series',
  extendSeries: 'Extend series',
  shortenMessage: "End {employee}'s series on {date}? Its shifts after that date will be cancelled, and they'll be notified.",
}
